import React from "react";
const Auth = React.createContext(null);
const CartsData = React.createContext(null);
const FutureOrdersData = React.createContext(null);
const OrderDetailsData = React.createContext(null);
const QuotationsData = React.createContext(null);
const OldOrderDetailsData = React.createContext(null);
const MedicinesRowData = React.createContext(null);
const MapOrderInvoice = React.createContext(null);
const UsersData = React.createContext(null);
const MedicineDeatilsData = React.createContext(null);
const CallBackContext = React.createContext(null);
const DeliveryContext = React.createContext(null);
const SupportContext = React.createContext(null);
const MarketingContext = React.createContext(null);
export {
  FutureOrdersData,
  OrderDetailsData,
  QuotationsData,
  CartsData,
  MedicinesRowData,
  Auth,
  OldOrderDetailsData,
  MapOrderInvoice,
  UsersData,
  MedicineDeatilsData,
  CallBackContext,
  DeliveryContext,
  SupportContext,
  MarketingContext
};
